export const EMPLOYER_PROFILE_COLUMNS_SMALL_DEVICES = [
    'Arbeitgeberprofil Basic',
    'Arbeitgeberprofil Plus',
    'branding.solution',
];

export const EMPLOYER_PROFILE_COLUMNS_LARGE_DEVICES = [
    'Produkte vergleichen',
    ...EMPLOYER_PROFILE_COLUMNS_SMALL_DEVICES,
];

export const FEATURES = [
    {
        rows: [
            {
                data: [{ value: true }, { value: true }, { value: false }],
                title: 'Online-Buchung',
            },
            {
                data: [{ value: true }, { value: true }, { value: false }],
                title: 'Selbsteingabe',
            },
            {
                data: [{ value: true }, { value: true }, { value: true }],
                title: 'KI-Eingabehilfe',
            },
            {
                data: [{ value: false }, { value: false }, { value: true }],
                title: 'Serviceeingabe',
            },
            {
                data: [
                    {
                        citation: 2,
                        label: '12 Monate',
                        value: true,
                    },
                    {
                        citation: 2,
                        label: '12 Monate',
                        value: true,
                    },
                    {
                        citation: 2,
                        label: '12 Monate',
                        value: true,
                    },
                ],
                description: 'Die Zeit, die ihr Arbeitgeberprofil online ist.',
                title: 'Laufzeit',
            },
        ],
    },
    {
        rows: [
            {
                data: [
                    {
                        label: '<span style="display: inline-flex;background-color: #8BC72A; padding:0 3px; border-radius:3px; color:white;line-height:16px;">EINBLICKE</span>',
                        value: true,
                    },
                    {
                        label: '<span style="display: inline-flex;background-color: #8BC72A; padding:0 3px; border-radius:3px; color:white;line-height:16px;">EINBLICKE</span>',
                        value: true,
                    },
                    {
                        label: '<span style="display: inline-flex;background-color: #8BC72A; padding:0 3px; border-radius:3px; color:white;line-height:16px;">EINBLICKE</span> <span style="display:inline-flex;background-color: #377800;padding:0 3px;border-radius:3px;color:white;line-height:16px;">VIDEOS</span>',
                        value: true,
                    },
                ],
                title: 'Hervorhebung in der Job- und Firmensuche',
            },
            {
                data: [{ value: true }, { value: true }, { value: true }],
                title: 'Werbefreiheit auf Ihrem Arbeitgeberprofil',
            },

            {
                data: [
                    { value: false },
                    { value: false },
                    {
                        label: 'Externes Werbepaket',
                        value: true,
                    },
                ],
                title: 'Werbung für Ihr Arbeitgeberprofil auf employer.page Arbeitgeberprofilen',
            },
        ],
        title: 'Sichtbarkeit auf karriere.at',
    },
    {
        rows: [
            {
                data: [{ value: true }, { value: true }, { value: true }],
                title: 'Unternehmenslogo',
            },
            {
                data: [{ value: true }, { value: true }, { value: true }],
                title: 'Unternehmensbeschreibung Über uns',
            },
            {
                data: [{ value: false }, { value: true }, { value: true }],
                title: 'Farboptionen entsprechend der Unternehmensmarke',
            },
            {
                data: [{ value: true }, { value: true }, { value: true }],
                title: 'Basisinformationen (Firmennamen, Unternehmensgröße, Branche, Standorte, Gründungsjahr)',
            },
            {
                data: [{ value: false }, { value: true }, { value: true }],
                title: 'Erweiterte Basisinformationen (Gesuchte Mitarbeiter*innen/Jahr, Gesuchte Positionen)',
            },
            {
                data: [{ value: false }, { value: true }, { value: true }],
                title: 'Erweiterter Text (Was wir bieten)',
            },
            {
                data: [{ value: false }, { value: false }, { value: true }],
                title: 'Erweiterter Text (Was wir machen)',
            },
            {
                data: [{ value: false }, { value: true }, { value: true }],
                title: 'Mission-Statement',
            },
            {
                data: [{ value: false }, { value: true }, { value: true }],
                title: 'Werte',
            },
            {
                data: [
                    { label: 'max. 9', value: true },
                    { label: 'max. 12', value: true },
                    { label: 'max. 32', value: true },
                ],
                description:
                    'Aus 32 standardisierten Benefits auswählbar, z.B. Aus- und Weiterbildung, Barrierefreiheit, Essenszulage, ' +
                    'Firmenwagen, Fitnessangebote, Gute Anbindung, Home Office, Hunde geduldet, Kantine uvm.',
                title: 'Mitarbeitenden-Benefits',
            },

            {
                data: [{ value: true }, { value: true }, { value: true }],
                title: 'Titelbild',
            },
            {
                data: [
                    { label: 'max. 12', value: true },
                    { label: 'max. 12', value: true },
                    { label: 'max. 21', value: true },
                ],
                title: 'Bilder',
            },
            {
                data: [
                    { value: false },
                    { label: 'max. 1', value: true },
                    { label: 'max. 5', value: true },
                ],
                title: 'Video-Intergration (YouTube oder Vimeo)',
            },
            {
                data: [
                    { value: false },
                    { value: false },
                    { label: 'max. 4', value: true },
                ],
                title: 'Integration karriere.reporter Videos',
            },
            {
                data: [
                    { value: false },
                    { label: 'max. 6', value: true },
                    { label: 'max. 6', value: true },
                ],
                description:
                    'In kurzen Statements haben Ihre Mitarbeitenden die Möglichkeit sich selbst vorzustellen. (max. 100 Zeichen)',
                title: 'Mitarbeitende stellen sich vor',
            },
            {
                data: [
                    { value: false },
                    { label: 'max. 3', value: true },
                    { value: false },
                ],
                description:
                    'Wählen Sie ein Bild mit max. 8 MB, in den Formaten .jp(e)g oder .png und einer ' +
                    'Mindestauflösung von 210x210 Pixel. Stellen Sie bis zu drei verschiedene Abteilungen aus ' +
                    'ihrem Unternehmen vor und beschreiben Sie, was diese einzigartig macht. (max. 400 Zeichen)',
                title: 'Gesamte Teamvorstellungen',
            },
            {
                data: [{ value: false }, { value: true }, { value: false }],
                title: 'Social Media Feed Integration (nur mobil)',
            },
            {
                data: [
                    { label: 'max. 1', value: true },
                    { label: 'max. 10', value: true },
                    { label: 'max. 10', value: true },
                ],
                description:
                    'Geben Sie folgende Informationen Ihrer Ansprechperson(en) an: Vorname, Nachname, ' +
                    'Position, Telefonnummer oder Email, Zitat (max. 100 Zeichen)',
                title: 'Präsentation von Ansprechperson(en)',
            },
            {
                data: [
                    { value: false },
                    { value: false },
                    { label: 'max. 3', value: true },
                ],
                title: 'Arbeitgeber-Auszeichnungen',
            },
            {
                data: [{ value: true }, { value: true }, { value: true }],
                title: 'Link zur eigenen Unternehmensseite',
            },
            {
                data: [{ value: true }, { value: true }, { value: true }],
                title: 'Link zur eigenen Karriereseite',
            },
            {
                data: [
                    { label: 'max. 5', value: true },
                    { label: 'max. 5', value: true },
                    { label: 'max. 8', value: true },
                ],
                title: 'Link zu Social Media Kanälen',
            },
            {
                data: [
                    { label: '1+19', value: true },
                    { label: '1+19', value: true },
                    { label: '1+19', value: true },
                ],
                description:
                    'Zum Haupstandort können max. 19 weitere Standorte angegeben werden.',
                title: 'Standort(e)-Präsentation',
            },
            {
                data: [{ value: true }, { value: true }, { value: false }],
                title: 'Aktualisierungsdatum des Arbeitgeberprofils',
            },
        ],
        title: 'Authentizität & Individualität auf dem Arbeitgeberprofil',
    },
    {
        rows: [
            {
                data: [
                    { value: false },
                    { value: false },
                    {
                        label:
                            '<p>wählbare Sichtkontakt-Pakete</p><br>' +
                            '<p>Basic (250.000 Sichtkontakte) <strong>oder</strong></p>' +
                            '<p>Regular (500.000 Sichtkontakte) <strong>oder</strong></p>' +
                            '<p>Large (1.000.000 Sichtkontakte)</p>',
                        value: true,
                    },
                ],
                title: 'Bewerbung im Google Werbenetzwerk',
            },
        ],
        title: 'Reichweite durch Bewerbungen online',
    },
    {
        rows: [
            {
                data: [{ value: false }, { value: false }, { value: true }],
                title: 'Video-Produktion von 4 karriere.reporter Videos',
            },
        ],
        title: 'Weitere Services (branding.solution)',
    },

    {
        rows: [
            {
                data: [{ value: true }, { value: true }, { value: true }],
                description:
                    'Im Business Portal erstellen und verwalten Sie Ihre Produkte und behalten die Performance Ihrer Stelleninserate im Blick.',
                title: 'Business Portal',
            },
        ],
        title: 'Inklusivleistungen',
    },
];
